var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"channels__info"},[_c('div',{staticClass:"channels__group"},[_c('span',[_vm._v(_vm._s(_vm.channelIDLabel))]),_c('span',{staticClass:"channels__description"},[_vm._v(_vm._s(_vm.channelID))])])])}
var staticRenderFns = []

export { render, staticRenderFns }